
export const sFechaPublicacion = '2026-04-14T11:27:08.2494647-06:00';
export const sVersion = 'vf1.1.604141127';
            